function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/** @module components/MetaBox */
import React from "react";
import $ from "jquery";
import { observer, inject } from "mobx-react";
import { Icon } from "react-aiot";
import { request, hooks, rmlOpts, i18n, getMediaDialogNextZIndex } from "../util";
import FolderBox, { FolderBoxHeader } from "./FolderBox";
import { Modal } from ".";
import store from "../store";
import { clone } from "mobx-state-tree";
/**
 * Show a meta box for the selected folder id. It also supports
 * user settings.
 *
 * @property {string|int} id The id of the folder or 'usersettings'
 * @extends React.Component
 */

var MetaBox = (_dec = inject("store"), _dec(_class = observer(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(MetaBox, _React$Component);

  var _super = _createSuper(MetaBox);

  function MetaBox(props) {
    var _this;

    _classCallCheck(this, MetaBox);

    _this = _super.call(this, props);

    _this.handleRef = function (ref) {
      _this.refSpan = ref;
      /**
       * The MetaBox ref element is ready and created.
       *
       * @event module:util/hooks#folder/meta
       * @param {HTMLElement} ref The reference
       * @param {string|id} id The folder id or 'usersettings'
       * @param {module:store~Store} store The store
       * @this MetaBox instance
       */

      hooks.call("folder/meta", [ref, _this.state.id, _this.props.store], _assertThisInitialized(_this));
    };

    _this.handleSave = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var form, serialize, data, response, message;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              form = $(_this.refSpan).children("form"), serialize = form.serializeArray(), data = {};
              $.each(serialize, function (key, value) {
                return data[value.name] = value.value;
              });
              /**
               * The MetaBox is serialized and ready to send.
               *
               * @event module:util/hooks#folder/meta/serialize
               * @param {string|id} id The folder id or 'usersettings'
               * @param {module:store~Store} store The store
               * @param {object} data The data prepared for the server so you can perhaps modify it
               * @param {HTMLElement} form The form container
               * @this MetaBox instance
               */

              hooks.call("folder/meta/serialize", [_this.state.id, _this.props.store, data, form], _assertThisInitialized(_this));
              _context.prev = 3;
              _context.next = 6;
              return request({
                location: {
                  path: _this.state.id === "usersettings" ? "/usersettings" : "/folders/" + _this.state.id + "/meta",
                  method: "PUT"
                },
                request: data
              });

            case 6:
              response = _context.sent;

              /**
               * The MetaBox is saved successfully.
               *
               * @event module:util/hooks#folder/meta/saved
               * @param {string|id} id The folder id or 'usersettings'
               * @param {object} response The server response
               * @param {object} data The data sent to the server
               * @this MetaBox instance
               */
              hooks.call("folder/meta/saved", [_this.state.id, response, data], _assertThisInitialized(_this));

              _this.props.onClose(true, response);

              _context.next = 15;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](3);
              message = _context.t0.responseJSON.message;

              _this.setState({
                errors: message
              });

            case 15:
              _context.prev = 15;

              _this.setState({
                loading: false
              });

              return _context.finish(15);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 11, 15, 18]]);
    }));
    _this.state = {
      id: 0,
      // The current visible id
      html: "",
      // The html
      loading: false,
      errors: []
    };
    return _this;
  }

  _createClass(MetaBox, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      var id = this.props.id;

      if (id !== this.state.id) {
        this.setState({
          id: id,
          html: ""
        });

        if (id !== false) {
          request({
            location: {
              path: id === "usersettings" ? "/usersettings" : "/folders/" + id + "/meta"
            }
          }).then(function (_ref3) {
            var html = _ref3.html;

            _this2.setState({
              html: html
            });
          }, function () {
            // An error occured
            _this2.setState({
              html: ""
            });
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var selected, modalContent, title;

      if (this.props.id === "usersettings") {
        selected = {
          icon: /*#__PURE__*/React.createElement(Icon, {
            type: "setting"
          }),
          title: rmlOpts.others.lang.userSettingsToolTipTitle
        };
      } else {
        selected = this.props.store.getTreeItemById(this.props.id, false);
      }

      var _this$state = this.state,
          html = _this$state.html,
          loading = _this$state.loading,
          errors = _this$state.errors;

      if (selected) {
        title = /*#__PURE__*/React.createElement(FolderBoxHeader, {
          icon: /*#__PURE__*/React.createElement(Icon, {
            type: "ellipsis"
          }),
          folder: selected
        });
        modalContent = /*#__PURE__*/React.createElement(FolderBox, {
          busy: !html || loading,
          folder: selected,
          errors: errors,
          header: false
        }, html && /*#__PURE__*/React.createElement("div", {
          className: "inside"
        }, /*#__PURE__*/React.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: html
          },
          style: {
            display: html ? "block" : "none"
          },
          ref: this.handleRef
        })));
      }

      return /*#__PURE__*/React.createElement(Modal, {
        visible: !!modalContent,
        title: title,
        onOk: this.handleSave,
        onCancel: this.props.onClose,
        cancelText: i18n("cancel"),
        okText: i18n("save"),
        zIndex: getMediaDialogNextZIndex(),
        confirmLoading: loading
      }, modalContent);
    }
  }]);

  return MetaBox;
}(React.Component)) || _class) || _class);
/**
 * Wait for the input field for the cover image and create a media picker.
 *
 * @see https://wordpress.stackexchange.com/questions/190987/how-do-i-create-a-custom-add-media-button-modal
 */

hooks.register("wprfc/metaCoverImage", function () {
  var modal = $(this).parents(".ant-modal-wrap").parent(),
      _$$wpMediaPicker$data = $(this).wpMediaPicker().data("wpWpMediaPicker"),
      _frame = _$$wpMediaPicker$data._frame; // Attach new store with new selected id


  var useStore = clone(store);
  useStore.getTreeItemById("all", false).setter(function (node) {
    return node.selected = true;
  });

  _frame.$el.data("useStore", useStore); // Listen to changes


  _frame.on("open", function () {
    return modal.hide();
  }).on("close", function () {
    return modal.show();
  });
});
export default MetaBox;